import React, { useContext, useEffect } from 'react';
import { Outlet, useNavigate, useSearchParams } from 'react-router-dom';
import { RestaurantGuardContext } from './RestaurantGuard';
import { mostCompatibleGroupSize } from '../helpers/groupSIze';
import { analytics, NAVIGATE_TO_PARAMS, NAVIGATE_TO_SEATING } from '../helpers/analytics';
import { getPatioSection } from '../helpers/getPatioSection';
import { useScreenSize } from '../hooks/useScreenSize';
import { getExploreEntryPath } from '../helpers/open-parameters/getExploreEntryPath';

export const SkipTrafficGuard = () => {
	const navigate = useNavigate();
	const [searchParams] = useSearchParams();
	const parentContext = useContext(RestaurantGuardContext);
	const { restaurant } = parentContext;

	const patioExists = Boolean(getPatioSection(parentContext.tables));

	const { isSmallScreen } = useScreenSize();

	const navigateToExplore = () => {
		const basePath = getExploreEntryPath(isSmallScreen);
		if (parentContext.featureFlags?.autoSelectGroupSize) {
			const groupSize = mostCompatibleGroupSize(parentContext.tables);
			analytics.track(NAVIGATE_TO_PARAMS, {
				from: 'Skip Traffic Guard',
				autoselectGroupSize: true,
				groupSize: groupSize
			});
			navigate(`${basePath}?groupSize=${groupSize}`);
		}
		else {
			analytics.track(NAVIGATE_TO_PARAMS, {
				from: 'Skip Traffic Guard',
				autoselectGroupSize: false,
				groupSize: null
			});
			navigate(basePath);
		}
	};

	useEffect(() => {
		if (searchParams.get('showSeating')?.toLowerCase() === 'true') {
			const navigateToSeating = (parentContext?.featureFlags?.patio && patioExists) || !!restaurant.settings?.alternativeBookingOption?.label;
			if (navigateToSeating) {
				analytics.track(NAVIGATE_TO_SEATING, {
					from: 'Skip Traffic Guard',
					autoselectGroupSize: false,
					groupSize: null
				});
				navigate('seating');
			}
			else {
				navigateToExplore();
			}
		}
		else if (searchParams.get('skip')?.toLowerCase() === 'true') {
			navigateToExplore();
		}
	}, [searchParams, isSmallScreen]);

	return <Outlet context={{ ...parentContext }} />;
};
